import { ChevronRight, Box, PencilRuler, DoorOpen, AppWindow, Building2, Upload } from 'lucide-react';

/**
 * @param {{
 *   activeBuildTool: string | null;
 *   onBuildToolChange: (tool: string | null) => void;
 *   onOpenLibrary: (mode: 'doors' | 'windows' | 'structures') => void;
 *   uploadContent?: import('react').ReactNode;
 *   showUpload?: boolean;
 * }} props
 */
function BuildPanel({
  activeBuildTool,
  onBuildToolChange,
  onOpenLibrary,
  uploadContent = null,
  showUpload = true,
}) {
  const directTools = [
    { id: 'room', label: 'Draw Room', Icon: Box },
    { id: 'wall', label: 'Draw Wall', Icon: PencilRuler },
  ];

  const libraryTools = [
    { id: 'doors', label: 'Place Doors', Icon: DoorOpen, mode: 'doors' },
    { id: 'windows', label: 'Place Windows', Icon: AppWindow, mode: 'windows' },
    { id: 'structures', label: 'Place Structures', Icon: Building2, mode: 'structures' },
  ];

  return (
    <div className="floor-plan-workspace-build-panel">
      {showUpload ? (
        <div className="floor-plan-workspace-build-section">
          {uploadContent || (
            <button type="button" className="btn btn-outline btn-sm floor-plan-workspace-build-upload" disabled>
              <Upload size={16} aria-hidden />
              <span>Upload 2D Floor Plan</span>
            </button>
          )}
        </div>
      ) : null}

      <ul className="floor-plan-workspace-build-list">
        {directTools.map(({ id, label, Icon }) => {
          const isActive = activeBuildTool === id;
          return (
            <li key={id}>
              <button
                type="button"
                className={`floor-plan-workspace-build-row${isActive ? ' floor-plan-workspace-build-row--active' : ''}`}
                onClick={() => onBuildToolChange(isActive ? null : id)}
                aria-pressed={isActive}
              >
                <Icon size={18} aria-hidden />
                <span>{label}</span>
              </button>
            </li>
          );
        })}
        {libraryTools.map(({ id, label, Icon, mode }) => (
          <li key={id}>
            <button
              type="button"
              className="floor-plan-workspace-build-row floor-plan-workspace-build-row--library"
              onClick={() => onOpenLibrary(/** @type {'doors' | 'windows' | 'structures'} */ (mode))}
            >
              <Icon size={18} aria-hidden />
              <span>{label}</span>
              <ChevronRight size={16} className="floor-plan-workspace-build-chevron" aria-hidden />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default BuildPanel;
